import { onDestroy } from 'svelte';

export function afterViewTransition(callback: (event: TransitionEvent) => void): void {
  const timeout = setTimeout(callback, 400);
  onDestroy(() => clearTimeout(timeout));
}
